import React from 'react';
import Block from '../../design-system/chat-blocks/Block';
import Pill from '../../design-system/primitives/Pill';
import Expandable, { expandedMaxHeight } from './Expandable';
import { fmtCompact, fmtInt, fmtUsd, titleCase } from './format';

const TokensBlock = ({ tokens }) => {
  const t = tokens.all_time;
  return (
    <Expandable>{(expanded) => (
    <Block
      icon="cpu"
      title="All LLM calls: tokens and estimated cost"
      badge={<Pill tone="accent">{fmtUsd(t.cost_usd)} all time</Pill>}
      footer={
        <span>
          Every LLM call recorded on {fmtInt(t.analyses_with_usage)} analyses, including preprocessing agents and notebook export, so this exceeds the billed per-turn tokens above. Cost uses the current price table, so old runs are re-priced.
          {t.truncated && ' Only the newest 5,000 analyses were scanned.'}
        </span>
      }
    >
      <div className="qa-token-totals">
        {[
          ['Input', t.input], ['Output', t.output], ['Cache read', t.cache_read], ['Cache write', t.cache_write],
        ].map(([label, v]) => (
          <div key={label} className="qa-token-total">
            <span className="qa-token-total__label">{label}</span>
            <span className="qa-token-total__value" title={fmtInt(v)}>{fmtCompact(v)}</span>
          </div>
        ))}
      </div>
      {tokens.by_model.length > 0 && (
        <div className="qa-table-wrap" style={{ maxHeight: expanded ? expandedMaxHeight : 320, margin: 0, border: '1px solid var(--line-soft)', borderRadius: 'var(--r-md)' }}>
          <table className="qa-table">
            <thead>
              <tr><th>Model</th><th className="qa-r">Input</th><th className="qa-r">Output</th><th className="qa-r">Cache read</th><th className="qa-r">Cost</th></tr>
            </thead>
            <tbody>
              {tokens.by_model.map((m) => (
                <tr key={m.model}>
                  <td className="qa-mono">{m.model}</td>
                  <td className="qa-r qa-mono">{fmtCompact(m.input)}</td>
                  <td className="qa-r qa-mono">{fmtCompact(m.output)}</td>
                  <td className="qa-r qa-mono">{fmtCompact(m.cache_read)}</td>
                  <td className="qa-r qa-mono">{fmtUsd(m.cost_usd)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      {tokens.by_phase.length > 0 && (
        <div className="qa-phase-list">
          {tokens.by_phase.slice(0, 8).map((p) => (
            <span key={p.phase} className="qa-phase">
              <span>{titleCase(p.phase)}</span>
              <span className="qa-mono">{fmtCompact(p.output_tokens)} out · {fmtUsd(p.cost_usd)}</span>
            </span>
          ))}
        </div>
      )}
    </Block>
    )}</Expandable>
  );
};

export default TokensBlock;
